import { readZip } from "./localFiles";

export const loadPublishedArchives = async (fetcher = fetch) => {
  const response = await fetcher("/published/index.json", { cache: "no-store" });
  if (!response.ok) throw new Error(`published archive index returned HTTP ${response.status}`);
  const payload = await response.json();
  if (!Array.isArray(payload?.archives)) throw new Error("published archive index has no archives");
  return payload.archives;
};

export const loadPublishedArchive = async (archive, fetcher = fetch) => {
  if (!archive?.url) throw new Error("published archive has no URL");
  const response = await fetcher(archive.url, { cache: "no-store" });
  if (!response.ok) throw new Error(`published archive returned HTTP ${response.status}`);
  return readZip(await response.arrayBuffer(), archive.name || archive.url);
};
